module.exports = __webpack_public_path__ + "static/media/process_section.ba3ef54e.PNG";